import { CheckCircleIcon } from "@heroicons/react/24/solid";

export default function SecondSectionFieldPro() {
  return (
    <section className="">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12 items-center">
        {/* Left */}
        <div>
         
          <h2 className="text-4xl md:text-5xl font-bold leading-tight mb-6">
            NextLoop <span className="text-[#92abc4]">FieldPro</span>
          </h2>
          <p className="text-gray-500 mt-4 max-w-xl leading-relaxed">
            NextLoop FieldPro is your trusted partner for professional cleaning, maintenance, and appliance care. Our experienced team delivers comprehensive solutions designed to keep your home, office, or commercial space running smoothly. From commercial and residential cleaning to building maintenance, air-conditioning repair, and a wide range of appliance services, we ensure every task is handled with precision, reliability, and professionalism. With NextLoop FieldPro, you can enjoy peace of mind knowing that your spaces and equipment are in capable hands, every time.
          </p>

          <ul className="mt-6 space-y-3">
            {[
              "Expert Cleaning Services",
              "Appliance Repair & Maintenance",
              "Trusted & Professional Team",
            ].map((item, i) => (
              <li key={i} className="flex items-center gap-2">
                <CheckCircleIcon className="w-5 h-5 text-orange-500 " />
                <span>{item}</span>
              </li>
            ))}
          </ul>

          <a
            href="tel:6591599414"
            className="mt-8 inline-block bg-orange-500 text-white px-6 py-3 rounded-xl hover:bg-blue-700 transition"
          >
            Enquire With Us
          </a>
        </div>

        {/* Right */}
        <div className="rounded-3xl overflow-hidden">
          <img
            src="https://images.unsplash.com/photo-1581578731548-c64695cc6952"
            alt="FieldPro cleaning and maintenance service"
            className="w-full h-full object-cover"
          />
        </div>
      </div>
    </section>
  );
}
